import { useEffect } from "react";
import { captureReferralFromUrl } from "@/lib/referral";

/**
 * Captures `?ref=<code>` from the landing URL on app boot.
 * Must mount before OAuth redirects so the code survives the round trip.
 */
export function ReferralCapture() {
  useEffect(() => {
    captureReferralFromUrl();
  }, []);
  return null;
}
